/* ============================================================
   CiemnaSzyba — buy box
   Zamiennik `class Component extends DCLogic` (linie 802–1124).
   ============================================================ */
(function () {
  "use strict";

  /* WARTOWNIK, nie etykieta. Do 31.08 była tu polska etykieta „Nie dotyczy",
     która pełniła obie role naraz. Po wejściu i18n etykieta jest tłumaczona,
     więc kod wartownika musiał się od niej oderwać — inaczej w EN/DE/CS
     `selectsDone` przestałoby widzieć komplet i sedan/kombi nie wysyłałyby
     `properties[Auto]` (PRZEKAZANIE §4.21). Ta sama wartość stoi w markupie
     jako <option value="__NA__">. Nie tłumaczyć, nie zmieniać. */
  var DOORS_NA = "__NA__";

  CS.onSection("[data-cs-product]", function (root) {

    /* ---- dane z Liquid --------------------------------------- */
    var variants = [];
    try {
      var raw = root.querySelector("[data-cs-variants]");
      variants = raw ? JSON.parse(raw.textContent) : [];
    } catch (e) {
      console.error("[cs] nie udało się sparsować macierzy wariantów", e);
    }

    var moneyFormat = root.getAttribute("data-money-format") || "{{amount}}";
    var MIX_VALUE = root.getAttribute("data-mix-value") || "Mieszany";
    var showAnchor = root.getAttribute("data-show-anchor") === "true";

    var form = root.querySelector("[data-cs-form]");
    var idInput = root.querySelector("[data-cs-variant-id]");
    var submitBtn = root.querySelector("[data-cs-submit]");
    var coverageBox = root.querySelector("[data-cs-coverage]");

    var zakresCards = CS.$$('[data-cs-action="zakres"]', root);
    var poziomCards = CS.$$('[data-cs-action="poziom"]', root);
    var mixToggle = root.querySelector("[data-cs-mix-toggle]");
    var mixFields = root.querySelector("[data-cs-mix-fields]");
    var poziomSingle = root.querySelector("[data-cs-poziom-single]");

    var sel = {
      marka: root.querySelector('[data-cs-car="marka"]'),
      model: root.querySelector('[data-cs-car="model"]'),
      generacja: root.querySelector('[data-cs-car="generacja"]'),
      nadwozie: root.querySelector('[data-cs-car="nadwozie"]'),
      drzwi: root.querySelector('[data-cs-car="drzwi"]')
    };

    var prop = {
      auto: root.querySelector('[data-cs-prop="auto"]'),
      manual: root.querySelector('[data-cs-prop="manual"]'),
      poziom: root.querySelector('[data-cs-prop="poziom"]'),
      przod: root.querySelector('[data-cs-prop="przod"]'),
      tyl: root.querySelector('[data-cs-prop="tyl"]'),
      wykroj: root.querySelector('[data-cs-prop="wykroj"]')
    };

    /* Opcja-wartownik „Nie dotyczy" w polu liczby drzwi. Trzymamy referencję do
       węzła z markupu, żeby wyjmować go i wkładać z powrotem bez odtwarzania
       (buildCascade nie przebudowuje tego selecta przez fillSelect). */
    var drzwiOpcjaNA = sel.drzwi ? sel.drzwi.querySelector('option[value="' + DOORS_NA + '"]') : null;

    var chip = {
      ok: root.querySelector('[data-cs-chip="ok"]'),
      kontakt: root.querySelector('[data-cs-chip="kontakt"]'),
      doplata: root.querySelector('[data-cs-chip="doplata"]')
    };

    /* ---- pasek CTA -------------------------------------------
       Pasek stoi POZA sekcją (hero ma isolation: isolate, przez co pasek
       w środku był przykrywany przez kolejne sekcje), więc `root` go nie
       obejmuje. Wiążemy po id sekcji, żeby przy dwóch wystąpieniach widgetu
       każdy pasek trafił do swojego konfiguratora, a nie do cudzego. */
    var sectionId = root.getAttribute("data-section-id");
    var sticky = sectionId
      ? document.querySelector('[data-cs-sticky][data-cs-sticky-section="' + sectionId + '"]')
      : null;
    var stickyCta = sticky ? sticky.querySelector("[data-cs-sticky-cta]") : null;

    /* Stan przycisku paska, czytany przez jego handler kliknięcia.
       ⚠ Uzupełniany WYŁĄCZNIE w render(), z tych samych zmiennych co buy box —
       żeby nie powstała druga, równoległa ocena kompletności konfiguratora.
       Gdyby te dwie oceny się rozjechały, pasek dodawałby do koszyka w stanie,
       w którym buy box uważa dane za niekompletne (albo odwrotnie). */
    var stanPaska = { blocked: true, autoDone: false };

    /* Jedno źródło prawdy dla buy boxu i paska: ta sama wartość trafia
       w oba miejsca, bez drugiej ścieżki formatowania ceny. */
    function wszystkie(selektor) {
      var lista = CS.$$(selektor, root);
      if (sticky) lista = lista.concat(CS.$$(selektor, sticky));
      return lista;
    }

    /* ---- stan startowy --------------------------------------- */
    var defZ = zakresCards.filter(function (c) { return c.classList.contains("is-selected"); })[0] || zakresCards[0];
    var defP = poziomCards.filter(function (c) { return c.classList.contains("is-selected"); })[0] || poziomCards[0];

    var store = CS.createStore({
      marka: "", model: "", generacja: "",
      nadwozieCode: "", nadwozieLabel: "", drzwi: "", drzwiLabel: "",
      manual: "",
      okna: defZ ? defZ.dataset.okna : "",
      coverage: defZ ? defZ.dataset.coverage : "",
      allowMix: defZ ? defZ.dataset.allowMix === "true" : false,
      poziom: defP ? defP.dataset.poziom : "",
      poziomLabel: defP ? defP.dataset.label : "",
      mix: false,
      mixPrzod: "",
      mixTyl: ""
    });

    /* ---- baza aut -------------------------------------------- */
    /* Skrypty `defer` wykonują się w kolejności dokumentu, a baza-aut.js
       jest wpięta PRZED tym plikiem — więc window.AUTA na pewno istnieje.
       Źródłowy polling co 120 ms + forceUpdate() jest niepotrzebny.
       Poniższe to asercja, nie fallback: jeśli kiedykolwiek zadziała,
       znaczy że popsuła się kolejność skryptów i chcemy o tym wiedzieć. */
    var AUTA = window.AUTA || null;
    if (!AUTA) {
      console.error("[cs] baza-aut.js nie wczytana — selektor auta wyłączony");
      Object.keys(sel).forEach(function (k) { if (sel[k]) sel[k].disabled = true; });
    }

    function rules() {
      return (AUTA && AUTA.reguly) || { drzwiAktywne: [], doplata: [], kontakt: [] };
    }
    /* Reguły WYŁĄCZNIE z AUTA.reguly. Źródło duplikowało je w kodzie strony
       jako DRZWI_ND = ["Sedan","Kombi","Cabrio"] i ["Bus / dostawczy","Pickup"],
       przez co pole drzwi było błędnie aktywne dla coupe/vana/busa/pickupa,
       a reguła dopłaty nie działała wcale. Nie odtwarzać tych list. */
    function czyDrzwi(code) { return AUTA && AUTA.czyDrzwi ? AUTA.czyDrzwi(code) : false; }
    function czyKontakt(code) { return AUTA && AUTA.czyKontakt ? AUTA.czyKontakt(code) : false; }
    function czyDoplata(code) { return AUTA && AUTA.czyDoplata ? AUTA.czyDoplata(code) : false; }

    function brandObj(name) {
      if (!AUTA) return null;
      for (var i = 0; i < AUTA.m.length; i++) if (AUTA.m[i].b === name) return AUTA.m[i];
      return null;
    }
    function modelObj(brand, name) {
      if (!brand) return null;
      for (var i = 0; i < brand.m.length; i++) if (brand.m[i].m === name) return brand.m[i];
      return null;
    }
    function genObj(model, label) {
      if (!model) return null;
      for (var i = 0; i < model.g.length; i++) if (model.g[i][0] === label) return model.g[i];
      return null;
    }

    function fillSelect(el, items, placeholder, current) {
      if (!el) return;
      var frag = document.createDocumentFragment();
      var o0 = document.createElement("option");
      o0.value = ""; o0.textContent = placeholder;
      frag.appendChild(o0);
      items.forEach(function (it) {
        var o = document.createElement("option");
        o.value = it.value; o.textContent = it.label;
        frag.appendChild(o);
      });
      el.replaceChildren(frag);
      el.value = current || "";
    }

    function buildCascade() {
      if (!AUTA) return;
      var s = store.get();

      fillSelect(sel.marka, AUTA.m.map(function (b) { return { value: b.b, label: b.b }; }), CS.t("select", "Wybierz…"), s.marka);

      var b = brandObj(s.marka);
      fillSelect(sel.model, b ? b.m.map(function (m) { return { value: m.m, label: m.m }; }) : [], CS.t("select", "Wybierz…"), s.model);
      sel.model.disabled = !b;

      var m = modelObj(b, s.model);
      fillSelect(sel.generacja, m ? m.g.map(function (g) { return { value: g[0], label: g[0] }; }) : [], CS.t("select", "Wybierz…"), s.generacja);
      sel.generacja.disabled = !m;

      var g = genObj(m, s.generacja);
      /* value = KOD nadwozia, tekst = etykieta.
         Reguły operują na kodach, więc kod musi zostać w stanie.
         ⚠ Etykieta idzie z i18n; `AUTA.n` pełni odtąd rolę ZAPASU (wartości
         polskie). Tłumaczy się `configurator.body.*`, nie baza-aut.js. */
      fillSelect(sel.nadwozie, g ? g[1].map(function (c) { return { value: c, label: CS.t("body." + c, (AUTA.n && AUTA.n[c]) || c) }; }) : [], CS.t("select", "Wybierz…"), s.nadwozieCode);
      sel.nadwozie.disabled = !g;

      var doorsAllowed = s.nadwozieCode && czyDrzwi(s.nadwozieCode);
      sel.drzwi.disabled = !s.nadwozieCode || !doorsAllowed;

      /* ⚠ „Nie dotyczy" jest WYBIERALNE wyłącznie tam, gdzie pole jest
         zablokowane — czyli nigdy przez klienta. Przy aktywnym polu opcja
         znika z listy, przy zablokowanym wraca, bo `sel.drzwi.value` musi mieć
         w co trafić, żeby wyłączone pole pokazało etykietę „Nie dotyczy".

         Dlaczego USUNIĘCIE, a nie `disabled`/`hidden` na opcji: liczba drzwi
         zmienia wykrój, a od czasu poprawki #1098 (§4.21) ręcznie wybrane
         „Nie dotyczy" znika z `properties[Auto]` bez śladu — zamówienie
         wygląda wtedy na kompletne, choć brakuje w nim danych potrzebnych
         do cięcia. Opcja wyszarzona nadal siedzi w `select.options` i daje się
         ustawić skryptem; usunięta nie istnieje.

         ⚠ KOLEJNOŚĆ: opcję trzeba dodać/usunąć PRZED przypisaniem `value`.
         Przypisanie `DOORS_NA` przy nieobecnej opcji cicho zostawia pustą
         wartość i pole pokazuje „Wybierz…". */
      if (drzwiOpcjaNA) {
        if (doorsAllowed) {
          if (drzwiOpcjaNA.parentNode) drzwiOpcjaNA.remove();
        } else if (!drzwiOpcjaNA.parentNode) {
          sel.drzwi.appendChild(drzwiOpcjaNA);
        }
      }

      sel.drzwi.value = s.drzwi || "";
    }

    /* ---- warianty -------------------------------------------- */
    function findVariant(okna, poziom) {
      for (var i = 0; i < variants.length; i++) {
        if (variants[i].o1 === okna && variants[i].o2 === poziom) return variants[i];
      }
      return null;
    }

    /* ---- opis auta ------------------------------------------- */
    /* JEDNO źródło segmentów dla `properties[Auto]` i dla chipa podsumowania.
       Wcześniej ten sam string składał się dwa razy niezależnie i obie kopie
       miały ten sam błąd — dlatego jest tu funkcja, a nie dwa literały.

       ⚠ Segment drzwi jest POMIJANY, gdy nadwozie ich nie ma. `s.drzwi` niesie
       wtedy DOORS_NA („Nie dotyczy") — to WARTOWNIK dla `selectsDone`, czyli
       etykieta interfejsu, nie dane. W zamówieniu #1098 wpadł dosłownie do
       wartości właściwości: „BMW Seria 3 F30/F31 (2011-2019) Kombi Nie dotyczy",
       widoczne dla klienta w koszyku, checkoucie i mailu potwierdzającym.

       Pomijamy segment, a NIE podstawiamy pustego stringa: przy `join(" ")`
       pusty element zostawiłby podwójną spację przed nadwoziem. Z tego samego
       powodu nie da się tu po prostu wyzerować `s.drzwi` — `selectsDone` (niżej)
       wymaga wartości prawdziwej, inaczej auta bez drzwi przestałyby wysyłać
       właściwość `Auto` w ogóle. Wartownik zostaje w stanie, znika w opisie. */
    function autoSegmenty(s) {
      var seg = [s.marka, s.model, s.generacja, s.nadwozieLabel];
      /* Do opisu idzie ETYKIETA drzwi, nie kod z <option value>. Od 31.08
         value to "3"/"5"/"__NA__", więc wpisanie tu `s.drzwi` dałoby
         w zamówieniu „… Kombi 3" zamiast „… Kombi 3-drzwiowe". */
      if (s.drzwi && s.drzwi !== DOORS_NA) seg.push(s.drzwiLabel);
      return seg.filter(Boolean);
    }

    /* ---- render ---------------------------------------------- */
    function render(s) {
      /* karty zakresu */
      zakresCards.forEach(function (c) {
        var on = c.dataset.okna === s.okna;
        c.classList.toggle("is-selected", on);
        c.setAttribute("aria-checked", on ? "true" : "false");
      });

      /* karty poziomu */
      poziomCards.forEach(function (c) {
        var on = c.dataset.poziom === s.poziom;
        c.classList.toggle("is-selected", on);
        c.setAttribute("aria-checked", on ? "true" : "false");
      });

      /* miks — dostępny tylko dla zakresów obejmujących przód i tył */
      if (mixToggle) {
        mixToggle.hidden = !s.allowMix;
        mixToggle.setAttribute("aria-pressed", s.mix ? "true" : "false");
        mixToggle.classList.toggle("is-on", s.mix);
      }
      var mixOn = s.allowMix && s.mix;
      if (mixFields) mixFields.hidden = !mixOn;
      if (poziomSingle) poziomSingle.hidden = mixOn;

      /* wariant */
      var poziomForVariant = mixOn ? MIX_VALUE : s.poziom;
      var v = findVariant(s.okna, poziomForVariant);

      if (!v) {
        console.error("[cs] brak wariantu", { okna: s.okna, poziom: poziomForVariant });
      }

      /* Nadwozie o nietypowym wykroju — reguła `kontakt` z AUTA.reguly, dziś
         `["bus", "pickup"]`.
         ⚠ NIE BLOKUJE JUŻ ZAKUPU (zmiana 02.08). Wcześniej wchodziło do `blocked`,
         przycisk zmieniał się w „Napisz do nas przed zamówieniem", a koszyk był
         niedostępny — sprzedaż dla tych nadwozi po prostu nie istniała. Teraz
         ścieżka zakupowa jest normalna, a nietypowość wykroju niesie komunikat
         w żółtym chipie i właściwość pozycji `Wykrój` (niżej).
         Nazwa reguły `kontakt` została w baza-aut.js bez zmian — zmieniło się
         znaczenie, nie lista nadwozi. */
      var wykrojDoPotwierdzenia = !!(s.nadwozieCode && czyKontakt(s.nadwozieCode));

      /* Nadwozie z dopłatą (coupe/cabrio). Liczone TUTAJ, obok reguły `kontakt`,
         bo obie flagi sterują teraz tym samym: czy zielony chip potwierdzający
         ma prawo się pokazać. Wcześniej `dop` powstawało dopiero w bloku chipa
         dopłaty, czyli PO zielonym — i dlatego zielony o nim nie wiedział. */
      var doplataWykroj = !!(s.nadwozieCode && czyDoplata(s.nadwozieCode));

      if (idInput) idInput.value = v ? v.id : "";

      /* `blocked` opisuje odtąd WYŁĄCZNIE dostępność wariantu. Nie dokładać tu
         reguł nadwozia — od tego jest `wykrojDoPotwierdzenia`. */
      var blocked = !v || !v.available;

      /* ---- KOMPLETNOŚĆ AUTA — jedno źródło prawdy ----------------
         Liczone TUTAJ, przed przyciskami, bo steruje naraz trzema rzeczami:
         etykietą paska CTA, wartością `properties[Auto]` (niżej) i bramką
         zakupu w `onSubmit`. Wcześniej stało 90 linii niżej i pasek musiał
         zgadywać etykietę, zanim wynik był znany.

         `manualDone` jest równoprawne z `selectsDone`: wpis ręczny to
         przewidziana droga dla aut spoza bazy i niesie do zamówienia
         `properties[Auto — wpis ręczny]`. Blokowanie go gubiłoby sprzedaż,
         a nie chroniło przed niczym. */
      var selectsDone = !!(s.marka && s.model && s.generacja && s.nadwozieCode && s.drzwi);
      var manualDone = s.manual.trim().length > 3;
      var carDone = manualDone || selectsDone;

      var etykietaCta = v && !v.available
        ? CS.t("unavailable", "Chwilowo niedostępne")
        : CS.t("add_to_cart", "Dodaj do koszyka");
      if (submitBtn) {
        /* ⚠ Przycisk NIE jest wygaszany przy niekompletnym aucie — celowo.
           Wyszarzony przycisk na telefonie wygląda jak awaria sklepu i nie mówi,
           czego brakuje. Klik przechodzi do `onSubmit`, które zatrzymuje wysyłkę
           i pokazuje komunikat przy konkretnym polu. `disabled` zostaje
           zarezerwowane dla niedostępnego wariantu, czyli stanu, w którym
           uzupełnianie czegokolwiek i tak nie pomoże. */
        submitBtn.disabled = blocked;
        submitBtn.textContent = etykietaCta;
      }

      /* Pasek CTA dodaje do koszyka tą samą ścieżką co buy box (patrz onStickyClick).
         Etykieta i stan wygaszenia lustrują przycisk z buy boxu — jeden sygnał,
         nie druga ocena. */
      /* ⚠ Dopóki auto nie jest kompletne, pasek PRZEWIJA do konfiguratora
         (patrz onStickyClick) — więc etykieta „Dodaj do koszyka" obiecywałaby
         co innego, niż przycisk robi. Na stronie głównej, gdzie klient widzi
         pasek zanim dojedzie do konfiguratora, to była najczęstsza pomyłka
         (QA mobilne 20.09). Przy niedostępnym wariancie pierwszeństwo ma
         „Chwilowo niedostępne" — to mocniejsza informacja niż „dobierz auto". */
      var etykietaPaska = blocked || carDone
        ? etykietaCta
        : CS.t("pick_car", "Dobierz do auta");
      if (sticky) {
        if (stickyCta) {
          stickyCta.textContent = etykietaPaska;
          stickyCta.classList.toggle("is-blocked", blocked);
          if (blocked) stickyCta.setAttribute("aria-disabled", "true");
          else stickyCta.removeAttribute("aria-disabled");
        }
      }

      /* cena — zawsze z wariantu, nigdy z kodu.
         ⚠ BYŁO `root.querySelector` w liczbie POJEDYNCZEJ: aktualizowany był
         wyłącznie pierwszy [data-cs-price] w DOM, czyli buy box. Pasek CTA
         pokazywał wariant domyślny niezależnie od wyboru zakresu i poziomu.
         Teraz jedno wywołanie formatMoney zapisuje do wszystkich miejsc naraz —
         przy miksie leci cena wariantu MIX_VALUE, bo `v` jest już wybrane wyżej. */
      var cena = v ? CS.formatMoney(v.price, moneyFormat) : null;
      if (cena) wszystkie("[data-cs-price]").forEach(function (el) { el.textContent = cena; });

      var anchor = showAnchor && v && v.compare > v.price;
      var cenaPrzed = anchor ? CS.formatMoney(v.compare, moneyFormat) : null;
      wszystkie("[data-cs-compare]").forEach(function (el) {
        el.hidden = !anchor;
        if (anchor) el.textContent = cenaPrzed;
      });
      var procent = anchor ? "−" + Math.round((1 - v.price / v.compare) * 100) + "%" : null;
      wszystkie("[data-cs-save]").forEach(function (el) {
        el.hidden = !anchor;
        if (anchor) el.textContent = procent;
      });

      /* podsumowanie */
      var poziomTxt = mixOn
        ? (CS.t("mix_front", "przód") + " " + s.mixPrzod + " / " + CS.t("mix_rear", "tył") + " " + s.mixTyl)
        : s.poziomLabel;
      var zakresLabel = "";
      zakresCards.forEach(function (c) { if (c.dataset.okna === s.okna) zakresLabel = (c.querySelector(".cs-zakres__name") || {}).textContent || ""; });
      var sumEl = root.querySelector("[data-cs-summary]");
      if (sumEl) sumEl.textContent = zakresLabel + " · " + poziomTxt;

      /* właściwości pozycji.
         ⚠ Shopify ZAPISUJE właściwość z pustą wartością, jeśli pole jest
         obecne w formularzu. „Nie wysyłać" musi więc znaczyć disabled. */
      /* ---- ZASADA PIERWSZEŃSTWA: lista vs wpis ręczny -----------
         Gdy klient wypełni jedno i drugie, do zamówienia lecą OBIE właściwości.
         Wpis ręczny jest w praktyce doprecyzowaniem („…wersja z szyberdachem”),
         a nie zaprzeczeniem wyboru z listy — odrzucenie którejkolwiek gubiłoby
         informację potrzebną przy docinaniu wykroju, a to kosztuje realny zwrot.

         `properties[Auto]` leci wyłącznie przy KOMPLETNYCH pięciu selectach:
         niepełny wybór nie niesie informacji, a zapisałby do zamówienia śmieć
         w rodzaju „Audi A4  sedan”.
         `properties[Auto — wpis ręczny]` leci, gdy pole nie jest puste. */
      /* `selectsDone` policzone wyżej, razem z `carDone` — nie liczyć drugi raz. */
      if (prop.auto) {
        prop.auto.value = selectsDone ? autoSegmenty(s).join(" ") : "";
        prop.auto.disabled = !selectsDone;
      }
      /* ⚠ Pole ręczne zostaje AKTYWNE bez względu na stan selektorów i na to,
         czy jest puste. Wcześniej stało tu `prop.manual.disabled = pusty`, co
         razem z `disabled` w markupie dawało zakleszczenie — pole nie dało się
         wypełnić nigdy. Odcięcie pustej wartości robi onSubmit niżej. */
      /* ⚠ `Poziom` NIE dostaje opisowego `poziomTxt`. Przy miksie leciały trzy
         właściwości niosące tę samą informację — Poziom „przód 30% / tył 5%",
         Przód „30%", Tył „5%" — więc Poziom jest teraz skrótem „Mieszany",
         a szczegóły zostają w Przód/Tył. Opisowa wersja żyje dalej wyłącznie
         w podsumowaniu na stronie (`[data-cs-summary]` wyżej), bo tam jest UI,
         nie dane zamówienia.
         Wartość bierze się z MIX_VALUE, czyli z `data-mix-value` — tej samej,
         po której `findVariant` szuka wariantu. Dzięki temu właściwość i opcja
         wariantu nie mogą się rozjechać przy zmianie nazwy opcji w adminie.
         ⚠ Pole jest hidden i NIGDY nie jest wyłączane — właściwość `Poziom`
         musi istnieć w każdym zamówieniu, bo opierają się na niej kwerendy
         operacyjne. Nie dodawać tu `disabled`. */
      if (prop.poziom) prop.poziom.value = mixOn ? MIX_VALUE : s.poziomLabel;
      if (prop.przod) prop.przod.disabled = !mixOn;
      if (prop.tyl) prop.tyl.disabled = !mixOn;

      /* `Wykrój = "do potwierdzenia"` — znacznik dla nadwozi z reguły `kontakt`.
         Odkąd te nadwozia da się normalnie kupić, zamówienie musi samo mówić,
         że wykrój wymaga potwierdzenia przed cięciem — inaczej wpadnie do
         backlogu nieodróżnialne od typowego. Wartość jest stała; rozróżnia
         sama OBECNOŚĆ właściwości.
         ⚠ „Nie wysyłać" = `disabled`, nie puste `value` — Shopify zapisuje
         właściwość z pustą wartością, jeśli pole jest obecne w formularzu. */
      if (prop.wykroj) prop.wykroj.disabled = !wykrojDoPotwierdzenia;

      /* chipy — `manualDone` i `carDone` policzone wyżej, przy przyciskach. */

      /* Sygnał dla paska CTA — te same dwie zmienne, którymi buy box steruje
         przyciskiem i chipem. Zakres okien i poziom mają w szablonie wartości
         domyślne (`is_default: true`), więc są wybrane od wejścia na stronę
         i NIE mogą być bramką. Bramką jest wyłącznie AUTO: pełna kaskada
         (`selectsDone`) albo wypełnione pole ręczne (`manualDone`). */
      stanPaska.blocked = blocked;
      stanPaska.autoDone = carDone;
      /* ⚠ Zielony chip NIE pokazuje się przy ŻADNYM nietypowym wykroju —
         ani przy regule `kontakt`, ani przy `doplata`. „Wykrój dobierzemy
         dokładnie pod to auto" obiecuje pewność, a oba żółte chipy mówią, że
         wykrój wymaga jeszcze potwierdzenia; wyświetlone naraz zaprzeczają
         sobie. Zostaje wyłącznie właściwy żółty. */
      if (chip.ok) {
        chip.ok.hidden = !carDone || wykrojDoPotwierdzenia || doplataWykroj;
        var t = chip.ok.querySelector("[data-cs-chip-text]");
        if (t) t.textContent = manualDone
          ? s.manual.trim()
          : autoSegmenty(s).join(" · ");
      }
      /* ⚠ Treść żółtego chipa jest STATYCZNA w main-product.liquid, nie
         wstrzykiwana stąd. Wcześniej szła z `AUTA.reguly.kontaktKomunikat`
         („…napisz do nas przed zamówieniem"), co po zdjęciu blokady byłoby
         nieprawdą — to już nie jest komunikat kontaktowy.
         ⚠ `kontaktKomunikat` zostało USUNIĘTE z baza-aut.js (02.08) — było już
         niczyje, a jego edycja dawała złudzenie zmiany treści. Nie przywracać;
         treść edytuje się w sekcji. */
      if (chip.kontakt) chip.kontakt.hidden = !wykrojDoPotwierdzenia;
      if (chip.doplata) {
        chip.doplata.hidden = !doplataWykroj;
        var dt = chip.doplata.querySelector("[data-cs-doplata-text]");
        /* doplataKwota jest null — pokazujemy wyłącznie informację,
           nic nie doliczamy do ceny. Sam chip dopłaty bez zmian. */
        if (dt && doplataWykroj) {
          var kwota = rules().doplataKwota;
          dt.textContent = kwota
            ? CS.t("custom_fee", "Nietypowy wykrój — dopłata {{ amount }}.")
                .replace("{{ amount }}", CS.formatMoney(kwota * 100, moneyFormat))
            : CS.t("custom_confirm", "Nietypowy kształt szyb — potwierdzimy wykrój mailowo przed cięciem.");
        }
      }

      /* podgląd zakresu */
      if (coverageBox && window.CSCoverage) window.CSCoverage.set(coverageBox, s.coverage);
    }

    /* ---- zdarzenia (delegacja) -------------------------------- */
    function onClick(e) {
      var btn = e.target.closest("[data-cs-action]");
      if (!btn || !root.contains(btn)) return;
      var action = btn.dataset.csAction;

      if (action === "zakres") {
        var allow = btn.dataset.allowMix === "true";
        store.set({
          okna: btn.dataset.okna,
          coverage: btn.dataset.coverage,
          allowMix: allow,
          mix: allow ? store.get().mix : false
        });
      } else if (action === "poziom") {
        store.set({ poziom: btn.dataset.poziom, poziomLabel: btn.dataset.label });
      } else if (action === "mix") {
        store.set({ mix: !store.get().mix });
      } else if (action === "qty-dec" || action === "qty-inc") {
        var q = root.querySelector("[data-cs-qty]");
        if (q) {
          var n = parseInt(q.value, 10) || 1;
          n = action === "qty-inc" ? Math.min(9, n + 1) : Math.max(1, n - 1);
          q.value = n;
        }
      }
    }

    function onChange(e) {
      var t = e.target;
      if (!root.contains(t)) return;

      /* Każdy ruch w kaskadzie zdejmuje komunikat. Zostawienie go po poprawieniu
         pola byłoby gorsze niż brak komunikatu — czerwona ramka na uzupełnionym
         polu mówi, że nadal jest źle. Kolejne brakujące pole pokaże się dopiero
         przy następnej próbie zakupu, nie samo z siebie. */
      czyscBlad();

      if (t.matches('[data-cs-car="marka"]')) {
        store.set({ marka: t.value, model: "", generacja: "", nadwozieCode: "", nadwozieLabel: "", drzwi: "", drzwiLabel: "" });
        buildCascade();
      } else if (t.matches('[data-cs-car="model"]')) {
        store.set({ model: t.value, generacja: "", nadwozieCode: "", nadwozieLabel: "", drzwi: "", drzwiLabel: "" });
        buildCascade();
      } else if (t.matches('[data-cs-car="generacja"]')) {
        store.set({ generacja: t.value, nadwozieCode: "", nadwozieLabel: "", drzwi: "", drzwiLabel: "" });
        buildCascade();
      } else if (t.matches('[data-cs-car="nadwozie"]')) {
        var code = t.value;
        var label = CS.t("body." + code, (AUTA && AUTA.n && AUTA.n[code]) || code);
        /* Liczba drzwi ma sens tylko dla hatchbacka i SUV-a (reguła pozytywna). */
        store.set({
          nadwozieCode: code,
          nadwozieLabel: label,
          drzwi: code && !czyDrzwi(code) ? DOORS_NA : "",
          drzwiLabel: code && !czyDrzwi(code) ? CS.t("doors_na", "Nie dotyczy") : ""
        });
        buildCascade();
      } else if (t.matches('[data-cs-car="drzwi"]')) {
        /* Kod z `value`, etykieta z tekstu opcji — tak samo jak przy nadwoziu. */
        store.set({ drzwi: t.value, drzwiLabel: t.selectedIndex >= 0 ? t.options[t.selectedIndex].textContent.trim() : "" });
      } else if (t.matches('[data-cs-prop="manual"]')) {
        store.set({ manual: t.value });
      } else if (t.matches('[data-cs-prop="przod"]')) {
        store.set({ mixPrzod: t.value });
      } else if (t.matches('[data-cs-prop="tyl"]')) {
        store.set({ mixTyl: t.value });
      }
    }

    function onInput(e) {
      if (e.target.matches('[data-cs-prop="manual"]')) {
        czyscBlad();
        store.set({ manual: e.target.value });
      }
      if (e.target.matches("[data-cs-qty]")) {
        var n = parseInt(e.target.value, 10);
        if (isNaN(n) || n < 1) n = 1;
        if (n > 9) n = 9;
        e.target.value = n;
      }
    }

    /* ⚠ „Nie wysyłać" nadal znaczy `disabled` — ale ustawiany DOPIERO przy
       wysyłce, nie na stałe. Handler `submit` wykonuje się PRZED zbudowaniem
       listy pól formularza, więc input wyłączony w tym miejscu nie trafia do
       żądania i Shopify nie zapisze właściwości z pustą wartością.
       Ani `value = ""`, ani usunięcie węzła nie dałyby tego efektu — Shopify
       zapisałby pustą właściwość, bo pole byłoby obecne w formularzu.
       setTimeout przywraca pole, gdyby nawigacja nie doszła do skutku (błąd
       sieci, cofnięcie); odpala się w kolejnym zadaniu, czyli już po serializacji. */
    function onSubmit(e) {
      /* ---- BRAMKA ZAKUPU (POLECENIE 13 §A) ----------------------
         Zamówienia #1167, #1247 i #1251 przyszły z `properties` zawierającymi
         wyłącznie `Poziom` — bez marki, modelu i rocznika, czyli bez danych
         do wycięcia paneli. Wszystkie trzy weszły z Facebooka na stronę główną,
         gdzie konfigurator stoi obok paska CTA.

         ⚠ To jedyne miejsce, które trzeba pilnować, bo w motywie jest JEDNA
         ścieżka dodania: natywny POST tego formularza. Przechodzą przez nią
         wszystkie trzy drogi klienta — klik w przycisk (`type="submit"`),
         Enter w formularzu i pasek CTA (`form.requestSubmit()`). `fetch`
         do `/cart/add` nie występuje w motywie (sprawdzone 20.09); gdyby
         kiedyś powstał, MUSI sam sprawdzić `stanPaska.autoDone` — inaczej
         obejdzie tę bramkę.

         Bramką jest `stanPaska.autoDone`, czyli dokładnie ten sam sygnał,
         którym pasek CTA decyduje, czy dodać, czy przewinąć. Jedno źródło
         prawdy: pełna kaskada ALBO wpis ręczny.

         ⚠ Nie blokujemy nadwozi z reguły `kontakt` (bus, pickup) — blokada
         zakupu dla nich została zdjęta 02.08 (PRZEKAZANIE §5e). „Brak auta"
         to co innego niż „nietypowe nadwozie". */
      if (!stanPaska.autoDone) {
        if (e && e.preventDefault) e.preventDefault();
        pokazBlad(pierwszeBrakujacePole());
        return;
      }
      czyscBlad();

      /* ⚠ „Nie wysyłać" nadal znaczy `disabled` — ustawiany DOPIERO tutaj,
         przy wysyłce. Kolejność ma znaczenie: bramka wyżej musi odrzucić
         wysyłkę ZANIM ruszymy pola, inaczej przy zablokowanym zakupie
         zostawilibyśmy `prop.manual` wyłączone na jedną turę pętli zdarzeń. */
      if (!prop.manual || prop.manual.value.trim().length > 0) return;
      prop.manual.disabled = true;
      setTimeout(function () { prop.manual.disabled = false; }, 0);
    }

    /* ---- klik w pasek CTA --------------------------------------
       Pasek DODAJE DO KOSZYKA, gdy auto jest wybrane, a przewija do
       konfiguratora, gdy go brakuje. Wcześniej przewijał zawsze — etykieta
       „Dodaj do koszyka" obiecywała więc co innego, niż przycisk robił,
       co na telefonie dezorientuje najbardziej.

       ⚠ ŚCIEŻKA DODANIA JEST TA SAMA CO W BUY BOKSIE, nie jej kopia:
       wywołujemy `form.requestSubmit()`, czyli natywną wysyłkę tego samego
       formularza. Dzięki temu lecą dokładnie te same właściwości pozycji,
       odpala się `onSubmit` (który odcina puste pole ręczne) i działa natywne
       przekierowanie POST → 302 → /cart. Ręczne `fetch` z `FormData` byłoby
       drugą ścieżką, którą trzeba by utrzymywać równolegle — i omijałoby
       `onSubmit`, przepuszczając pustą właściwość (§4.21).
       ⚠ `form.submit()` NIE odpala zdarzenia `submit`, więc jest wyłącznie
       awaryjne i poprzedzone ręcznym `dispatchEvent`.

       Węzeł zostaje `<a href="#konfigurator">` celowo: bez JS przewinięcie
       jest jedynym bezpiecznym zachowaniem — bez wybranego auta poleciałby
       wariant domyślny, czyli zamówienie bez danych do cięcia. */
    function przewinDo(el) {
      if (!el) return;
      el.scrollIntoView({ behavior: "smooth", block: "center" });
      /* preventScroll, bo przewijanie już trwa; na `<select>` focus nie
         otwiera listy, więc nie porywa ekranu w trakcie animacji. */
      if (el.focus) el.focus({ preventScroll: true });
    }

    /* Pierwsze niewypełnione pole kaskady — tam ląduje przewinięcie, zamiast
       na sam początek sekcji. Kolejność jak w interfejsie. */
    function pierwszeBrakujacePole() {
      var s = store.get();
      if (!s.marka) return sel.marka;
      if (!s.model) return sel.model;
      if (!s.generacja) return sel.generacja;
      if (!s.nadwozieCode) return sel.nadwozie;
      if (!s.drzwi) return sel.drzwi;
      return prop.manual;
    }

    /* ---- komunikat przy polu -----------------------------------
       Tekst stoi w markupie, przetłumaczony Liquidem — tutaj tylko zdejmujemy
       `hidden`. Dzięki temu komunikat jedzie zwykłą ścieżką tłumaczeń motywu
       i nie trzeba go przepychać przez most `CS.t`.

       ⚠ JEDNO pole naraz. Pięć czerwonych ramek naraz mówi „wszystko źle",
       a nie „uzupełnij to"; klient ma wiedzieć, co zrobić w następnym ruchu. */
    var poleWBledzie = null;

    function czyscBlad() {
      if (!poleWBledzie) return;
      var pole = poleWBledzie.closest ? poleWBledzie.closest("[data-cs-field]") : null;
      if (pole) {
        pole.classList.remove("is-error");
        var kom = pole.querySelector("[data-cs-err]");
        if (kom) kom.hidden = true;
      }
      poleWBledzie.removeAttribute("aria-invalid");
      poleWBledzie = null;
    }

    function pokazBlad(el) {
      czyscBlad();
      if (!el) return;
      var pole = el.closest ? el.closest("[data-cs-field]") : null;
      if (pole) {
        pole.classList.add("is-error");
        var kom = pole.querySelector("[data-cs-err]");
        if (kom) kom.hidden = false;
      }
      el.setAttribute("aria-invalid", "true");
      poleWBledzie = el;
      przewinDo(el);
    }

    function onStickyClick(e) {
      e.preventDefault();
      if (!stanPaska.blocked && stanPaska.autoDone && form) {
        if (form.requestSubmit) form.requestSubmit();
        else if (form.dispatchEvent(new Event("submit", { bubbles: true, cancelable: true }))) form.submit();
        return;
      }
      /* `stanPaska.blocked` to od 02.08 WYŁĄCZNIE niedostępny wariant — nadwozia
         z reguły `kontakt` nie blokują już zakupu. W tym stanie przewijamy do
         sekcji, bo nie ma pojedynczego pola do uzupełnienia.

         ⚠ Przy braku auta pasek pokazuje DOKŁADNIE to samo co przycisk główny
         (`pokazBlad`, które samo przewija), a nie samo przewinięcie. Inaczej
         te same dwa kliknięcia dawałyby dwa różne skutki: z buy boxu komunikat
         przy polu, z paska ciche przewinięcie bez wyjaśnienia — a na telefonie
         to właśnie pasek jest pierwszym, co klient naciska. */
      if (stanPaska.blocked) przewinDo(root);
      else pokazBlad(pierwszeBrakujacePole());
    }

    root.addEventListener("click", onClick);
    root.addEventListener("change", onChange);
    root.addEventListener("input", onInput);
    if (form) form.addEventListener("submit", onSubmit);
    if (stickyCta) stickyCta.addEventListener("click", onStickyClick);

    /* ---- start ------------------------------------------------ */
    if (prop.przod) store.set({ mixPrzod: prop.przod.value });
    if (prop.tyl) store.set({ mixTyl: prop.tyl.value });

    store.subscribe(render);
    buildCascade();
    render(store.get());

    /* ---- sprzątanie (edytor motywu) --------------------------- */
    return function () {
      root.removeEventListener("click", onClick);
      root.removeEventListener("change", onChange);
      root.removeEventListener("input", onInput);
      if (form) form.removeEventListener("submit", onSubmit);
      if (stickyCta) stickyCta.removeEventListener("click", onStickyClick);
    };
  });
})();
